import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { HTTPError } from '@/utils/http'
import pkg from '../../package.json'

export default {
  install: app => {
    if (process.env.NODE_ENV === 'development') {
      return
    }

    if (!process.env.VUE_APP_SENTRY_DSN) {
      throw new Error('sentry DSN not provided')
    }

    Sentry.init({
      dsn: process.env.VUE_APP_SENTRY_DSN,
      integrations: [new VueIntegration({
        Vue: app,
        attachProps: true
      })],
      environment: process.env.VUE_APP_SENTRY_ENV || process.env.NODE_ENV,
      logErrors: true,
      release: pkg.version,
      beforeSend (event, { originalException }) {
        if (originalException instanceof HTTPError) {
          event.level = Sentry.Severity.Debug
        }

        return event
      }
    })
  }
}
